module.exports = __webpack_public_path__ + "static/media/sims-hero-background.dcd4754b.png";